import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=b5175ee0&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"
import style0 from "./schedule.vue?vue&type=style&index=0&id=b5175ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5175ee0",
  null
  
)

export default component.exports